import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Alert, Table, TableBody, TableCell, TableHead, TableRow, TableContainer } from '@mui/material';
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';
import PersonAddAltIcon from '@mui/icons-material/PersonAddAlt';
import NoteAddOutlinedIcon from '@mui/icons-material/NoteAddOutlined';
import ShoppingCartOutlinedIcon from '@mui/icons-material/ShoppingCartOutlined';
import AssignmentReturnOutlinedIcon from '@mui/icons-material/AssignmentReturnOutlined';
import api from '../api/api';

const tones = ['#18b87a', '#148bff', '#ffa732', '#ee3f63', '#8592ad'];
const labels = { available: 'Доступны', rented: 'В аренде', maintenance: 'В ремонте', unavailable: 'Недоступны' };
export default function DashboardOverview() {
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [failed, setFailed] = useState(false);
  useEffect(() => {
    let active = true;
    api.get('/dashboard/overview', { skipLoading: true }).then(res => { if (active) setData(res.data); })
      .catch(() => { if (active) setFailed(true); });
    return () => { active = false; };
  }, []);
  const statuses = data?.asset_statuses || [];
  const total = statuses.reduce((sum, item) => sum + item.count, 0);
  let cursor = 0;
  const stops = statuses.map((item, index) => {
    const start = cursor; cursor += total ? item.count / total * 100 : 0;
    return `${tones[index % tones.length]} ${start}% ${cursor}%`;
  });
  return <>
    {failed && <Alert severity="warning" sx={{ mb: 2 }}>Не удалось загрузить последние сделки и статусы активов.</Alert>}
    <div className="erp-dashboard-panels">
      <section className="erp-dashboard-panel">
        <h2>Последние сделки</h2>
        <TableContainer><Table size="small" aria-label="Последние сделки"><TableHead><TableRow><TableCell>№</TableCell><TableCell>Клиент</TableCell><TableCell>Статус</TableCell><TableCell align="right">Сумма</TableCell></TableRow></TableHead>
          <TableBody>{(data?.latest_deals || []).map(deal => <TableRow key={deal.id}>
            <TableCell><Button size="small" onClick={() => navigate(`/rental-deals/edit/${deal.id}`)}>№{deal.number}</Button></TableCell>
            <TableCell>{deal.client}</TableCell><TableCell>{deal.status}</TableCell><TableCell align="right">{Number(deal.amount).toLocaleString('ru-RU')} ₽</TableCell>
          </TableRow>)}</TableBody></Table></TableContainer>
        {!data?.latest_deals?.length && <p style={{ color: '#657797' }}>{failed ? 'Данные временно недоступны' : data ? 'Сделок пока нет' : 'Загрузка сделок…'}</p>}
        <Button onClick={() => navigate('/rental-deals')} sx={{ mt: 1 }}>Открыть все сделки →</Button>
      </section>
      <section className="erp-dashboard-panel"><h2>Быстрые действия</h2>
        {[[Inventory2OutlinedIcon,'Добавить актив','/assets/edit/new'],[PersonAddAltIcon,'Добавить клиента','/clients/edit/new'],[NoteAddOutlinedIcon,'Создать сделку','/rental-deals/edit/new'],[ShoppingCartOutlinedIcon,'Оформить закупку','/procurement'],[AssignmentReturnOutlinedIcon,'Оформить возврат','/returns']].map(([Icon,label,path]) => <Button key={path} fullWidth className="erp-quick-link" onClick={() => navigate(path)} startIcon={<Icon />}>{label}</Button>)}
      </section>
      <section className="erp-dashboard-panel"><h2>Статусы активов</h2>
        <div className="erp-ring" style={{ background: total ? `conic-gradient(${stops.join(',')})` : '#edf2f8' }}><div><strong>{data ? total : '—'}</strong><small>всего активов</small></div></div>
        {statuses.map((item,index) => <div key={item.name} className="erp-status-line"><i style={{ background: tones[index % tones.length] }} /><span>{labels[item.name] || item.name}</span><strong>{item.count}</strong><span>{total ? Math.round(item.count/total*100) : 0}%</span></div>)}
        <Button fullWidth onClick={() => navigate('/assets')}>Все активы →</Button>
      </section>
    </div>
  </>;
}
